import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useT } from "@/lib/i18n";

export const CONTACT_EMAIL = "fuelhaulerpro@gmail.com";

// Shared layout for the Privacy and About pages.
export function InfoPage({ testid, title, sub, sections, children, heading = "h3" }) {
  const t = useT();
  const nav = useNavigate();
  const H = heading;
  return (
    <div className="screen" data-testid={testid}>
      <header className="sites-header">
        <div><h1 className="header-title">{t(title)}</h1>{sub && <div className="header-sub">{sub}</div>}</div>
        <button type="button" className="header-btn" data-testid={`${testid}-close`} aria-label={t("Close")}
          onClick={() => (window.history.state?.idx > 0 ? nav(-1) : nav("/"))}><X size={20} /></button>
      </header>
      <div className="screen-body terms-body">
        {children}
        {sections.map(([h, p], i) => (
          <section key={h} data-testid={`${testid}-section-${i}`}>
            <H className="terms-h">{t(h)}</H>
            {(Array.isArray(p) ? p : [p]).map((x) => <p key={x} className="terms-p">{t(x, { email: CONTACT_EMAIL })}</p>)}
          </section>
        ))}
        <a className="gate-link" href={`mailto:${CONTACT_EMAIL}`} data-testid={`${testid}-email`}>{CONTACT_EMAIL}</a>
      </div>
    </div>
  );
}
